export const searchConfig = {
  defaultOptions: {
    updateQueryString: true,
    requestSearchResults: true,
    resetPagination: true,
  },
  updateQueryString: {
    updateQueryString: true,
    requestSearchResults: false,
    resetPagination: false,
  },
};